<template>
  <div>
    <Headersys ref="Headersys" />
    <div class="content">
      <!-- 头 -->
      <BsznCurrent :steps="2" />
      <!-- border="1" cellspacing="0" -->
      <!-- class="first-column" -->
      <!-- class="sticky-column" -->
      <table
        class="table"
        id="table"
        ref="table"
        cellspacing="0"
        style="border-collapse: collapse; margin-left: 5px; width: 650px"
      >
        <tr>
          <td style="width: 500px; padding: 5px; border: 0" colspan="2">
            <div
              style="
                text-align: center;
                font-weight: bold;
                padding-bottom: 10px;
              "
            >
              {{ details.NAME }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            实施主体
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ details.ORG_NAME }}
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            受理条件
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            <div v-for="(item, idx) in conditionList" :key="idx">
              {{ idx + 1 }}.{{ item.NAME }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            申请材料
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            <div v-for="(item, idx) in materialList" :key="idx">
              {{ idx + 1 }}.{{ item.NAME
              }}<span v-if="item.MUST == '1'"> (必要)</span
              ><span v-else> (非必要)</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            法定时限
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ details.LAW_TIME }}个工作日
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            承诺时限
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ details.AGREE_TIME }}个工作日
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            受理地点
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ details.ADDRESS }}
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            受理时间
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ details.OFFICE_HOUR }}
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            咨询电话
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ consultInfo.CONSULTINGPHONE }}
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            投诉电话
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            {{ consultInfo.COMPLAINTSHOTLINE }}
          </td>
        </tr>
        <tr>
          <td
            style="
              width: 150px;
              vertical-align: top;
              text-align: center;
              padding: 5px;
              font-weight: bold;
              border: 1px solid #000;
            "
          >
            是否收费
          </td>
          <td style="width: 500px; padding: 5px; border: 1px solid #000">
            <div v-if="details.IS_CHARGE == '0'">不收费</div>
            <div v-else>收费</div>
          </td>
        </tr>
        <tr>
          <td
            style="width: 500px; padding: 5px; border: 0"
            colspan="2font-size: 16px;"
          >
            <div style="float: right; width: 230px">
              <div style="padding: 10px 0">奎文区自助服务终端</div>
              <div>打印日期：{{ today }}</div>
            </div>
          </td>
        </tr>
      </table>
      <div class="section-box">
        <div class="realy-content">
          <div class="section-code-box">
            <div>
              <canvas id="qrCode"></canvas>
              <div class="qr-tips">手机扫描二维码</div>
              <div class="qr-tips">查看办事指南</div>
            </div>
          </div>
          <div class="section-content-box">
            <div class="side-box">
              <div class="side-title">事项名称</div>
              <div class="side-item">
                {{ details.NAME }}
              </div>
            </div>
            <!-- 111 -->
            <div class="side-box">
              <div class="side-title">实施主体</div>
              <div class="side-item">
                {{ details.ORG_NAME }}
              </div>
            </div>
            <!-- <div class="side-box">
            <div class="side-title">
              服务对象
            </div>
            <div class="side-item">
              详情
            </div>
          </div> -->
            <div class="side-box">
              <div class="side-title">受理条件</div>
              <div class="side-item">
                <div v-for="(item, idx) in conditionList" :key="idx">
                  {{ idx + 1 }}.{{ item.NAME }}
                </div>
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">申请材料</div>
              <div
                class="side-item"
                v-for="(item, idx) in materialList"
                :key="idx"
              >
                {{ idx + 1 }}.{{ item.NAME
                }}<span class="red must" v-if="item.MUST == '1'">(必要)</span
                ><span v-else class="must">(非必要)</span>
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">法定时限</div>
              <div class="side-item">{{ details.LAW_TIME }}个工作日</div>
            </div>
            <div class="side-box">
              <div class="side-title">承诺时限</div>
              <div class="side-item">{{ details.AGREE_TIME }}个工作日</div>
            </div>
            <div class="side-box">
              <div class="side-title">受理地点</div>
              <div class="side-item">
                {{ details.ADDRESS }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">受理时间</div>
              <div class="side-item">
                {{ details.OFFICE_HOUR }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">咨询电话</div>
              <div class="side-item">
                {{ consultInfo.CONSULTINGPHONE }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">投诉电话</div>
              <div class="side-item">
                {{ consultInfo.COMPLAINTSHOTLINE }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">是否收费</div>
              <div class="side-item">
                <div v-if="details.IS_CHARGE == '0'">不收费</div>
                <div v-else>收费</div>
              </div>
            </div>
            <div style="height: 10rem"></div>
          </div>
        </div>
      </div>
      <Back
        print="2"
        @toPrintEve="toPrintEve"
        :declaration="syType == 0 ? false : true"
        @toDeclaration="toDeclaration"
      />
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";
import domtoimage from "dom-to-image";
export default {
  name: "",
  data() {
    return {
      //
      details: {}, //详情
      materialList: [], //申请材料
      conditionList: [], //受理条件
      consultInfo: {}, //咨询投诉
      code: "",
      loadingInstance: null,
      waitTime: 280,
      watiTimer: null,
      today: "",
      maskShow: false,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      declarationUrl: "", //在线申报地址
      syType: 0,
    };
  },
  created() {
    //
    this.code = this.$route.query.code;
    this.getDetails();
    this.getShenCL();
    this.getSLTJ();
    this.getConsult();
    this.today = this.$fun.getTime(new Date());
    this.declarationUrl =
      "http://wfzwfw.sd.gov.cn/wf/icity/proinfo/index?code=" + this.code;
    this.syType = localStorage.getItem("bstype");
  },
  mounted() {
    //
    this.useqrcode();
    this.timeDown();
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
      this.$rqt.print_saveClickRecord({
        fname: this.name,
        fcerno: this.idCard,
        phone: this.phone,
        fmac: this.fmac,
        fitemid: this.code,
        fitem: this.details.NAME,
      });
    });
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 在线申报
    toDeclaration() {
      var tyLogin = this.$store.state.tyLogin;
      if (!tyLogin) {
        this.$refs.Headersys.tongyiEvent();
        return;
      }
      ipcRenderer.send("open-Certification", this.declarationUrl);
    },
    generateIMG() {
      console.log("开始生成");
      var node = document.getElementById("table");
      var _this = this;
      // 先用domtoimage获取到HTML转化后图片后，已base64方式保存
      domtoimage.toPng(node).then(function (dataUrl) {
        // console.log(dataUrl);
        // return
        // "data:image/png;base64,"
        dataUrl = dataUrl.replace("data:image/png;base64,", "");
        _this.localPrint(dataUrl);
      });
    },
    localPrint(base64String) {
      this.$rqt.localhost_print({
        base64String,
      });
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 280;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    toPrintEve() {
      var userInfo = this.$store.state.suerInfo;
      this.name = userInfo.name;
      this.phone = userInfo.tel;
      this.idCard = userInfo.cerno;
      if (!this.name) {
        this.$refs.Headersys.chooseLoginType();
        return;
      }
      this.$rqt
        .print_save({
          type: this.details.NAME,
          fmac: this.fmac,
          name: this.name,
          phone: this.phone,
          idCard: this.idCard,
        })
        .then((res) => {
          if (res.code == 200) {
            this.maskShow = true;
            setTimeout(() => {
              this.loadingInstance = Loading.service({
                fullscreen: true,
                text: "正在打印...",
                target: document.querySelector("#loadDom"),
              });
            }, 500);
            setTimeout(() => {
              this.loadingInstance.close();
              this.maskShow = false;
            }, 16000);
            // this.generateIMG()
            // var dom = document.getElementById('table');
            const domElement = this.$refs.table;
            var dom = domElement.outerHTML;
            var html =
              '<!DOCTYPE html> <html lang = "en" > <head> <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>Document</title></head><body>' +
              dom +
              "</body></html>";
            // console.log(html);
            // 将字符串转换为Blob对象
            const blob = new Blob([html], { type: "text/plain;charset=utf-8" });

            // 创建File对象
            const fileObject = new File([blob], "filename.html", {
              type: "html/plain",
            });
            // console.log(fileObject);
            let params = new FormData();
            params.append("file", fileObject);
            this.$rqt.print_genHtml(params).then((res) => {
              // console.log(res);
              // domain
              // filePath
              var data = res.data;
              var url = data.domain + data.filePath.substring(1);
              // var urls = url.replace("http://172.16.2.9", "http://123.131.74.135")
              var urls = url.replace(
                "http://172.16.2.11",
                "http://123.131.74.138"
              );
              console.log(urls);
              lodop.tablePrint(urls);
            });
            // return
            // lodop.tablePrint(dom, this.details.NAME)
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定",
              lockScroll: false,
            });
          }
        });
    },
    //获取事项详情
    getDetails() {
      this.$rqt
        .division_sendUr2({
          url: "getItemInfoByItemCode",
          params: {
            regionCode: "370705000000",
            itemCode: this.code,
            infoType: "info",
          },
        })
        .then((res) => {
          // console.log(JSON.parse(res.data));
          this.details = JSON.parse(res.data).ItemInfo[0];
        });
    },
    // 申请材料
    getShenCL() {
      this.$rqt
        .division_sendUr2({
          url: "getItemInfoByItemCode",
          params: {
            regionCode: "370705000000",
            itemCode: this.code,
            infoType: "material",
          },
        })
        .then((res) => {
          // console.log('申请材料', JSON.parse(res.data));
          this.materialList = JSON.parse(res.data).ItemInfo;
        });
    },
    // 受理条件
    getSLTJ() {
      this.$rqt
        .division_sendUr2({
          url: "getItemInfoByItemCode",
          params: {
            regionCode: "370705000000",
            itemCode: this.code,
            infoType: "condition",
          },
        })
        .then((res) => {
          // console.log('受理条件',JSON.parse(res.data));
          this.conditionList = JSON.parse(res.data).ItemInfo;
        });
    },
    // 咨询投诉
    getConsult() {
      this.$rqt
        .division_sendUr2({
          url: "getItemInfoByItemCode",
          params: {
            regionCode: "370705000000",
            itemCode: this.code,
            infoType: "consult",
          },
        })
        .then((res) => {
          // console.log('咨询投诉', JSON.parse(res.data));
          this.consultInfo = JSON.parse(res.data).ItemInfo[0];
        });
    },
    useqrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        `http://wfzwfw.sd.gov.cn/wf/icity/proinfo/index?code=${this.code}`,
        function (error) {
          if (error) {
            console.error(error);
          } else {
            // console.log("success!");
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #f1fafc;
  position: relative;
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: red;
}

.section-box {
  // display: flex;
  // align-items: center;
  // background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2rem;
  position: relative;

  .realy-content {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 2rem;
  }

  .section-code-box {
    width: 20%;
    height: calc(100vh - 93rem);
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba($color: #000000, $alpha: 0.1);

    .qr-tips {
      text-align: center;
      font-weight: bold;
      margin-bottom: 3rem;
      font-size: 5rem;
    }
  }

  .section-content-box {
    width: 80%;
    height: calc(100vh - 93rem);
    overflow-y: scroll;

    .side-box {
      width: 95%;
      margin: auto;
      padding: 4rem 0 5rem;
      border-bottom: 2px solid #dfdcdf;

      .side-title {
        font-size: 5rem;
        font-weight: bold;
        color: #55a5ff;
        margin-bottom: 3rem;
      }

      .side-item {
        font-size: 4rem;
      }
    }
  }

  .section-content-box::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}

#qrCode {
  width: 30rem !important;
  height: 30rem !important;
  display: block;
  margin: 0 auto 5rem;
}

.must {
  margin-left: 3rem;
}

.red {
  color: #ff0000;
}

.table {
  position: fixed;
  // top: 999rem;
  // left: 999rem;
  top: 0;
  left: 0;
  z-index: -999;
}
</style>